import React from "react";
import { styled } from "styled-components";
const StyledFormActionsWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-left: -0.25rem;

  & > * {
    margin-bottom: 1rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }
`;
export const FormActionsWrapper = ({ children }) => (React.createElement(StyledFormActionsWrapper, null, children));
export default FormActionsWrapper;
//# sourceMappingURL=index.js.map